
import { EpimsBaseEntityDto } from './epim-base.dto';
import { FacilityRegisterHostDto } from './facility-register-host.dto';
export class FacilityRegistrationDto extends EpimsBaseEntityDto {

   FacilityRegistrationName: string;
   FacilityRegistrationCode: string;
   StateId: string;
   CountryId: string;
   LgaId: string;
   Description: string;
   DateAcquired: Date;
   DateRegistered: Date;
   Status: string;
   ActivityStatus: string;
   Location: string;
   facilityRegisterHosts: FacilityRegisterHostDto[]
}




